import { loadColumnsConfig } from '@openx/components-table/parts/sections/utils';
import { TableName } from '@openx/components-table/Table';
import type { BaseRow, Columns } from '@openx/types/tableHelpers';

const EXPORT_COLUMNS_BY_LIST_COLUMN: Record<string, readonly string[]> = {
  audience: ['audience_name', 'audience_status'],
  buyer_names: ['buyer_names'],
  cpm: ['cpm', 'cpm_delta'],
  created_date: ['created_date'],
  deal_price: ['deal_price', 'currency'],
  dsp_names: ['dsp_names'],
  end_date: ['end_date'],
  health_score: ['health_score', 'health_state'],
  impressions: ['impressions', 'impressions_delta'],
  modified_date: ['modified_date'],
  name: ['name', 'deal_id', 'status', 'sync_status'],
  package_uid: ['package_id', 'package_name', 'package_notes'],
  partner_revenue: ['partner_revenue', 'partner_revenue_delta'],
  pmp_deal_type: ['pmp_deal_type'],
  publisher_cpm: ['publisher_cpm', 'publisher_cpm_delta'],
  publisher_revenue: ['publisher_revenue', 'publisher_revenue_delta'],
  spend: ['spend', 'spend_delta'],
  start_date: ['start_date'],
};

const DEAL_UID_COLUMN = 'uid';

const LEGACY_PUB_DSP_COLUMNS = ['brand_names', 'open_auction_access', 'lifetime_impression_goal', 'created_by_user_id'];

const ORGANIZATION_COLUMN = 'account_name';
const NAME_COLUMN = 'name';

type ResolveOptions = {
  includeLegacyPubDspColumns?: boolean;
  includeOrganization?: boolean;
};

export const resolveDealExportColumns = <RowT extends BaseRow>(
  columns: Columns<RowT>,
  { includeLegacyPubDspColumns = false, includeOrganization = false }: ResolveOptions = {}
): string[] => {
  const shown = loadColumnsConfig(columns, TableName.DEALS).filter(column => !column.hide);

  const keys = shown.flatMap(column => {
    const exportColumns = EXPORT_COLUMNS_BY_LIST_COLUMN[column.key] ?? [];

    return column.key === NAME_COLUMN && includeOrganization
      ? [...exportColumns, ORGANIZATION_COLUMN]
      : [...exportColumns];
  });

  return includeLegacyPubDspColumns
    ? [...new Set([DEAL_UID_COLUMN, ...keys, ...LEGACY_PUB_DSP_COLUMNS])]
    : [...new Set(keys)];
};
